import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@patternfly/react-core';
import { HOW_TO_BUY_URL } from 'config/constants';
import { storesContext } from 'stores';

import '../styles.scss';

const AccessLearningSubscription = () => {
  const { t } = useTranslation();
  const { userStore } = useContext(storesContext);
  const howToBuyUrl =
    userStore.enablementsConfigurations?.subscription_to_unlock_url ||
    HOW_TO_BUY_URL;

  return (
    <React.Fragment>
      <div className="no-enrollment">
        <div className="no-enrollment__explore-subscription">
          <h3>{t('Build your skills with trusted industry-lead training')}</h3>
          <p>
            {t(
              'Red Hat Learning Subscription offers expert-led training on cloud, AI, virtualization, and automation. Build expertise and get certified through structured learning paths and hands-on labs to maximize Red Hat platforms.',
            )}
          </p>
          <a href={howToBuyUrl} target="_blank" rel="noreferrer">
            <Button>{t('Learn more')}</Button>
          </a>
        </div>
      </div>
    </React.Fragment>
  );
};

export default observer(AccessLearningSubscription);
